import { Collection } from '@/components/integration/collection'

export const Integrations = () => {
  return (
    <>
      <Collection />
    </>
  )
}
